import Card from "@erecht24/frontend-kit/theme/components/cards/Card";
import CardBody from "@erecht24/frontend-kit/theme/components/cards/CardBody";
import PlanVariant from "./PlanVariant";
import {StateContext} from "../Contexts";
import {useContext} from "react";
import {getCurrentPlan, getCurrentPlanVariant} from "../Billwerk/SubscriptionJS";
import {track} from "../Util/tracking";

export default function () {
    /** @type CheckoutState */
    const state = useContext(StateContext);

    let plan = getCurrentPlan(state);
    let planVariant = getCurrentPlanVariant(state);

    if (planVariant?.recurring_fee < 0.01)
        return null;

    return <Card>
        <CardBody>
            <div className="flex items-start self-stretch justify-center lg:justify-between mb-10 gap-6">
                <div className="flex flex-1 flex-col items-center lg:items-start justify-start gap-2">
                    {state.cartViewData && (
                        <>
                            {planVariant?.name_override && <h3 className="h3 text-center lg:text-left text-balance lg:text-wrap">{planVariant?.name_override}</h3>}
                            {(!planVariant?.name_override && plan?.name) && <h3 className="h3 text-center lg:text-left text-balance lg:text-wrap">{plan.name}</h3>}
                            {(!planVariant?.name_override && !plan?.name) &&
                                <h3 className="h3 text-center lg:text-left text-balance lg:text-wrap skeleton w-full">&nbsp;</h3>}
                            <div className="flex flex-row self-stretch justify-evenly lg:justify-between">
                                <button className="text-blue text-lg underline hover:text-gray-very-dark"
                                        onClick={() => track(
                                            () => state.setPlanDetailsOpen(!state.planDetailsOpen),
                                            'checkout',
                                            'check_tariff_details',
                                            'check_details'
                                        )}
                                >Details
                                </button>
                            </div>
                        </>
                    )}
                    {!state.cartViewData && (
                        <>
                            <h3 className="h3 h-[30px] w-[150px] skeleton"></h3>
                            <button className="text-lg skeleton w-[50px] h-[24px]"></button>
                        </>
                    )}
                </div>
            </div>
            <PlanVariant></PlanVariant>
        </CardBody>
    </Card>
}
